import React from "react";
import { useChatContext } from "../../../../../../providers/Chat";
import { useGlobalContext } from "../../../../../../providers/global";
import { getShortDate } from "../../../../../../utils/date";

import {
  StyledChatCard,
  StyledAvatar,
  StyledUserInfo,
  StyledUserName,
  StyledMessage,
  StyledMessageCount,
  StyledCount,
  StyledDate
} from "./ChatCard.style";

const defaultAvatar = "https://www.w3schools.com/howto/img_avatar.png";

const ChatCard = ({ chat }) => {
  const { createdAt, messages, participants, unSeenCount } = chat;
  const lastMessage = messages[messages.length - 1];
  const { setSelectedChat, selectedChat } = useChatContext();
  const { currentUser } = useGlobalContext();
  const handleOnClick = () => {
    setSelectedChat(chat);
  };

  const participantsWithoutCurrentUser = participants.filter(
    p => p.id !== currentUser.id
  );

  return (
    <StyledChatCard
      onClick={handleOnClick}
      active={chat.id === selectedChat?.id}
    >
      <StyledAvatar
        src={participantsWithoutCurrentUser[0]?.image || defaultAvatar}
      />
      <StyledUserInfo>
        <StyledUserName>
          {participantsWithoutCurrentUser.map(({ name }) => name).join(", ")}
        </StyledUserName>
        {lastMessage && (
          <StyledMessage> {lastMessage.message.content}</StyledMessage>
        )}
      </StyledUserInfo>

      <>
        <StyledMessageCount>
          {unSeenCount > 0 && <StyledCount> {unSeenCount}</StyledCount>}
          <StyledDate>{getShortDate(createdAt)}</StyledDate>
        </StyledMessageCount>
      </>
    </StyledChatCard>
  );
};

export default ChatCard;
